import React from 'react';
import { uiBtn, type UiBtnVariant } from './buttonClasses';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: UiBtnVariant | 'secondary';
  size?: 'sm' | 'md' | 'lg';
  loading?: boolean;
  fullWidth?: boolean;
  /** Toggle / segmented controls */
  pressed?: boolean;
  children: React.ReactNode;
}

const sizeClass: Record<'sm' | 'md' | 'lg', string> = {
  sm: 'ui-btn--sm',
  md: 'ui-btn--md',
  lg: 'px-6 py-3 text-base',
};

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  loading = false,
  fullWidth = false,
  pressed,
  disabled,
  children,
  className = '',
  ...props
}) => {
  const mappedVariant = variant === 'secondary' ? 'secondary' : variant;
  const widthClass = fullWidth ? 'w-full' : '';
  const isDisabled = disabled || loading;

  const classes = [
    uiBtn(mappedVariant as UiBtnVariant, {
      pressed,
      size: size === 'lg' ? 'md' : size,
    }),
    size === 'lg' ? sizeClass.lg : '',
    widthClass,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button className={classes} disabled={isDisabled} {...props}>
      {loading ? (
        <>
          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-current mr-2" />
          {children}
        </>
      ) : (
        children
      )}
    </button>
  );
};
